import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import NetworkUserCard from '@/components/cards/network/user-card/user-card';
// import TopProvidersCard from './top-providers-card/top-providers-card';
import {getSum} from '@/utils/utils';
import {formatTime} from '@/utils/date';
import NetworkStrugglingCompetencyCard from '@/components/cards/network/struggle-comp-card/struggle-comp-card';
import { SubjectModel } from '@/models/drill-down/subject';
import { CompetencyModel } from '@/models/drill-down/competency';
import { DrillDownModel } from '@/models/drill-down/drill-down';
import { numberFormat } from '@/helpers/number-format';
import moment from 'moment';
import { sessionService } from '@/providers/services/auth/session';
import { DEMO_USERS } from '@/utils/constants';

import NetworkPerformanceCard from '@/components/cards/network/performance-card/performance-card';
import NetworkTimespentCard from '@/components/cards/network/timespent-card/timespent-card';

import { PerformanceData } from '@/models/groups/performance';
import { GroupsReport, ReportData, StruggleData } from '@/models/groups/report';
import { ReportOverallStats, ReportDataCoordinate, ReportDataDrilldown} from '@/models/groups/report';
import { TimespentDrilldown, TimespentData, ClassTimespentData } from '@/models/groups/timespent';
import { ClassCompetencyData, ReportPerformanceStatsModel } from '@/models/groups/class';
import { appConfigService } from '@/providers/services/app/app-config';
import { SubjectsModel } from '@/models/groups/subjects';
import { UsersData } from '@/models/groups/users';
import LearningChallenge from '@/components/cards/network/learning-challenge/learning-challenge';

@Component({
    name: 'drilldown-performance',
    components: {
        'material-icon': GoogleMaterialIcon,
        'network-user-card': NetworkUserCard,
        // 'top-providers': TopProvidersCard,
        'network-struggling-competency-card': NetworkStrugglingCompetencyCard,
        'network-performance-card': NetworkPerformanceCard,
        'network-timespent-card': NetworkTimespentCard,
        'learning-challenge': LearningChallenge,
    },
})

export default class DrilldownPerformance extends Vue {


    get session() {
        return sessionService.getSession();
    }

    /**
     * Checking is tenant user are not
     */
    get isTenant() {
        const access = this.$access;
        return access.hasPermission(access.menus.network, access.ACL.compDrillAnalytic);
    }

    private get newUsersCount() {
        const overallStats: any = this.usersDrillDownData.overallStats;
        return overallStats ? overallStats.totalUsers : 0;
    }

    private get userGain() {
        return this.stubData ? this.stubData.user_gain || {} : {};
    }

    private get compGainedUserPercent() {
        return this.stubData && this.stubData.gained_comp ?
            (this.stubData.gained_comp[this.activeMonth] || this.stubData.gained_comp.default) + '%' :
            '0%';
    }

    private get compGain() {
        return this.stubData ? this.stubData.comp_gain || {} : {};
    }

    private get tsGain() {
        return this.stubData ? this.stubData.ts_gain || {} : {};
    }

    private get strugglingCompetenciesStub() {
        return this.stubData ? this.stubData.struggling_competencies || [] : [];
    }

    private get lastMonth() {
        return moment(this.activeMonth, 'MM').subtract(1, 'months').format('MMM');
    }

    private get currentMonth() {
        return moment(this.activeMonth, 'MM').format('MMM');
    }


    private get groupLabel() {
        const accessibleLevels = appConfigService.getUserGroupAccessLevel();
        const competencyData = this.groupType === 'class' ? this.classCompetencyData : this.competencyData;
        if (competencyData) {
            const activeLevelIndex = accessibleLevels.findIndex((level: any) => level.type === competencyData.type);
            return this.groupType === 'class' ? 'student' : activeLevelIndex >= 0 ?
            accessibleLevels[activeLevelIndex + 1] ? accessibleLevels[activeLevelIndex + 1].name :
            competencyData.type : competencyData.type;
        } else {
            return 'class';
        }
    }

    get isLearningChallenge() {
      return appConfigService.getLearningChallenge();
    }

    @Prop()
    public performanceData!: PerformanceData;

    @Prop()
    public competencyData!: ReportData ;

    @Prop()
    public timespentData!: TimespentData;

    @Prop()
    public classTimespentData!: ClassTimespentData;

    private gainedCardLabel = this.$access.isDemoGroup ? 'Learners Gained  > 10 Competencies' : 'Students Gained  > 10 Competencies';

    @Prop()
    private stubData!: any;

    @Prop()
    private classCompetencyData!: ClassCompetencyData;

    @Prop()
    private groupType!: string;

    @Prop()
    private groupId!: string;

    @Prop()
    private countryData: any;
    @Prop()
    private selectedDate: any;
    @Prop()
    private subjectsList?: SubjectModel[];

    @Prop()
    private seletedLevel?: DrillDownModel;
    @Prop()
    private cardDetails: any;
    @Prop()
    private studentList: any;
    @Prop({ default: false })
    private isLoading!: boolean;
    @Prop({default: appConfigService.isDemoTenant()})
    private isDemoTenant!: boolean;
    @Prop()
    private isAtInitialLevel!: boolean;
    @Prop()
    private activeMonth!: string;

    @Prop()
    private subjectList!: SubjectsModel;

    @Prop({default: false})
    private isRestrictClass!: boolean;

    @Prop()
    private usersDrillDownData!: UsersData;

    @Prop()
    private parentGroupName!: any;

    @Prop()
    private activeYear: any;

    @Prop({default: []})
    private strugglingCompetencies!: StruggleData;

    @Prop()
    private activeSubject!: any;

    @Prop()
    private learningReportData!: any;

    @Prop()
    private competencyPerformance!: ReportPerformanceStatsModel;

    @Prop()
    private groupName: any;

    // -------------------------------------------------------------------------------
    // Methods
    private numberFormat(value: number) {
        return numberFormat(value);
    }

    private onSelectLevel(level: any, subject: any, pullUp: any) {
        this.$emit('onSelectLevel', level, subject, pullUp);
    }

    private onGoUpward( subject: any, pullUp: any, active: any) {
        this.$emit('onGoUpward', subject, pullUp, active);
    }

    private onSelectStrunggleSubject(subject: any) {
        this.$emit('onSelectStrunggleSubject', subject);
    }
}
